// extracted by mini-css-extract-plugin
module.exports = {"texts":"styles_texts__nWkf4","text":"styles_text__3f22G"};